export default "__VITE_ASSET__Vs6T7_BA__"